module.exports = __webpack_public_path__ + "img/calendar-week.fbb0a160.svg";